import React, { useState } from 'react';
import { Gallery } from '../components/sections/Gallery';
import { ImageModal } from '../components/sections/ImageModal';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  return (
    <div className="pt-32 sm:pt-40" data-testid="gallery-page">
      <Gallery onSelectImage={setSelectedImage} />
      <ImageModal image={selectedImage} onClose={() => setSelectedImage(null)} />
    </div>
  );
};

export default GalleryPage;
